<template>
  <bonus-dialog
    class="bonusDialogAd"
    :close-counter-number="5"
    @close-dialog="$emit('close-dialog','AD')">
    <div class="bonusDialogAd_container">
      <img
        :src="adPic"
        class="bonusDialogAd_img"
        @click="handleOpenLink(adUrl)">
    </div>
  </bonus-dialog>
</template>

<script>
import BonusDialog from './BonusDialog'
export default {
  name: 'BonusDialogAd',
  components: {
    BonusDialog
  },
  props: {
    adPic: {
      type: String
    },
    adUrl: {
      type: String
    }
  },
  methods: {
    handleOpenLink (url) {
      window.location.href = url
    }
  }
}
</script>

<style scoped>
.bonusDialogAd {
  max-width: 320px !important;
  height: calc(320px + 28px);
  padding: 28px 0 0 0 !important;
}

.bonusDialogAd_container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.bonusDialogAd_img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/xbb/components/BonusDialogAd.vue